document.addEventListener("DOMContentLoaded", () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const endValue = parseInt(element.dataset.value);
          const isExperiment = element.classList.contains("experiments-number");
          let startTime;

          function animate(currentTime) {
            if (!startTime) startTime = currentTime;
            const progress = Math.min((currentTime - startTime) / 2000, 1); // 2 seconds duration

            const easedProgress = 1 - Math.pow(1 - progress, 4); // Ease out quart
            const currentValue = Math.round(easedProgress * endValue);

            if (isExperiment) {
              element.textContent = `${currentValue}+ EXPERIMENTS`;
            } else {
              element.textContent = `${currentValue}%`;
            }

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
          observer.unobserve(element);
        }
      });
    },
    { threshold: 0.5 }
  );

  // Observe both percentage stats and experiments count
  document
    .querySelectorAll(".stat-number, .experiments-number")
    .forEach((stat) => {
      observer.observe(stat);
    });
});
